module.exports = __webpack_public_path__ + "static/media/anim.e2b2e6b3.gif";